import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { baseurl } from '../Baseurl';
import axiosInstance from '../api/axiosInstance';

const loadInitialUser = () => {
	try {
		const stored = localStorage.getItem('userMedical');
		if (!stored) return null;
		const parsed = JSON.parse(stored);
		return parsed?.data || null;
	} catch {
		return null;
	}
};

export const updateProfile = createAsyncThunk(
	'user/updateProfile',
	async ({ form, file }, { rejectWithValue }) => {
		try {
			const userId = JSON.parse(localStorage.getItem('userMedical'))?.data?.id;
			if (!userId) return rejectWithValue('Authentication required');

			const formDataToSend = new FormData();
			if (form.fullName) formDataToSend.append('fullName', form.fullName);
			if (form.email) formDataToSend.append('email', form.email);
			if (form.phoneNumber) formDataToSend.append('phoneNumber', form.phoneNumber);
			if (form.dateOfBirth) formDataToSend.append('dateOfBirth', form.dateOfBirth);
			if (form.gender) formDataToSend.append('gender', form.gender);
			if (form.role) formDataToSend.append('role', form.role);
			if (file) formDataToSend.append('personalPhoto', file);

			const response = await axiosInstance.put(`updateDoctorDetails/${userId}`, formDataToSend, {
				headers: { 'Content-Type': 'multipart/form-data' }
			});

			const updatedData = response?.data?.data || response?.data || {};

			const currentUserData = JSON.parse(localStorage.getItem('userMedical')) || { data: {} };
			const mergedData = { ...currentUserData.data, ...form };

			const tryExtractPhoto = (obj) => {
				if (!obj || typeof obj !== 'object') return null;
				const possibleKeys = [
					'personalPhoto','personal_photo','photo','image','avatar','profileImage','profile_image','profilePhoto','profile_photo','personalPhotoUrl','url','path','filePath','filename'
				];
				for (const key of possibleKeys) {
					if (obj[key]) return obj[key];
				}
				for (const value of Object.values(obj)) {
					if (value && typeof value === 'object') {
						const found = tryExtractPhoto(value);
						if (found) return found;
					}
				}
				return null;
			};

			const newPhoto = tryExtractPhoto(updatedData);
			if (newPhoto) mergedData.personalPhoto = newPhoto;
			Object.keys(updatedData || {}).forEach((key) => {
				if (!['personalPhoto','personal_photo','photo'].includes(key)) {
					mergedData[key] = updatedData[key];
				}
			});

			const next = { ...currentUserData, data: mergedData };
			localStorage.setItem('userMedical', JSON.stringify(next));
			if (mergedData?.fullName) {
				localStorage.setItem('userName', mergedData.fullName);
				localStorage.setItem('fullName', mergedData.fullName);
			}
			if (mergedData?.personalPhoto) {
				localStorage.setItem('userPersonalPhoto', String(mergedData.personalPhoto));
			}
			localStorage.setItem('profilePhotoBust', String(Date.now()));
			window.dispatchEvent(new CustomEvent('profile-updated'));

			return mergedData;
		} catch (e) {
			return rejectWithValue(e?.response?.data || 'Update failed');
		}
	}
);

const userSlice = createSlice({
	name: 'user',
	initialState: {
		user: loadInitialUser(),
		loading: false,
		error: null
	},
	reducers: {
		setUser(state, action) {
			state.user = action.payload;
		},
		logout(state) {
			state.user = null;
			localStorage.clear();
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(updateProfile.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(updateProfile.fulfilled, (state, action) => {
				state.loading = false;
				state.user = action.payload;
			})
			.addCase(updateProfile.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload || 'Update failed';
			});
	}
});

export const { setUser, logout } = userSlice.actions;
export default userSlice.reducer;





